var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import VariantsContainer from './VariantsContainer';
import React from 'react';
import ReactDOM from 'react-dom';
const init = () => __awaiter(void 0, void 0, void 0, function* () {
    const variantsContainer = document.querySelector('[data-variants-container]');
    const customContext = document.getElementById('cardigang-custom-context');
    if (customContext) {
        const productHandle = customContext.dataset.product;
        const contextData = JSON.parse(customContext.innerText);
        // Add Ons: Default products
        if (variantsContainer) {
            let addOnData = yield fetch(`${window.Shopify.routes.root}products/${productHandle}?view=variants-context`).then((data) => data.json());
            addOnData = Object.assign(Object.assign({}, contextData), addOnData);
            ReactDOM.render(React.createElement(VariantsContainer, Object.assign({}, addOnData)), variantsContainer);
        }
    }
});
export default {
    init,
};
